import { Platform } from "@ionic/angular";
import { Injectable } from "@angular/core";
import { AffiliateTrackerInterface } from "../../interfaces/affliation-interface";
import { FacebookEvents } from 'capacitor-facebook-events';
import { AdvertisingId } from "@capacitor-community/advertising-id";
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: "root",
})

export class FacebookTracker implements AffiliateTrackerInterface {
    private IDFA: string;
    private IDFV: any;

    constructor(
        protected platform: Platform
    ){}

    initialize(): Promise<AffiliateTrackerInterface> {
        return new Promise(async (resolve_tracker, reject_tracker) => {
            try {
                if (this.platform.is('ios')) {
                    this.IDFV = (await Device.getId()).identifier;

                    const trackingStatus = await AdvertisingId.requestTracking();
                    console.log("FB: ATT status:", trackingStatus.value);

                    const advertisingId = await AdvertisingId.getAdvertisingId();
                    console.log("FB: advertising-id:", JSON.stringify(advertisingId));
                    this.IDFA = advertisingId.id;

                    await this.setAdvertiserTrackingEnabled();
                    resolve_tracker(this);
                } else if (this.platform.is('android')) {
                    const advertisingId = await AdvertisingId.getAdvertisingId();
                    console.log("FB: advertising-id:", JSON.stringify(advertisingId));
                    this.IDFA = advertisingId.id;

                    await this.setAdvertiserTrackingEnabled();
                    resolve_tracker(this); 
                } else {
                    console.warn("Platform not supported for Facebook events.");
                    resolve_tracker(this);
                }
            } catch (error) {
                console.error("Error during MetaClientService initialization:", error);
                reject_tracker(error); 
            }
        });
    }

    public getAdvertisingIDs() {
        return {
            IDFA: this.IDFA,
            IDFV: this.IDFV
        };
    }

    private setAdvertiserTrackingEnabled(): Promise<AffiliateTrackerInterface> {
        return new Promise((resolve_tracker, reject_tracker) => {
            FacebookEvents.setAdvertiserTrackingEnabled({enabled: true}).then(res => {
                resolve_tracker(this);
            }).catch(err => {
                console.log("FB: initialize failed");
                reject_tracker(this);
            });
        });
    }

    public logEvent(eventName: string, params?: any): void {
        if (!eventName) {
            console.warn("FB: Event name is required to log an event.");
            return;
        }
    
        if (params && typeof params !== 'object') {
            console.error("FB: Event parameters must be an object.");
            return;
        }
    
        if (params) {
            FacebookEvents.logEvent({
                event: eventName,
                params: params,
            }).then(() => {
                console.log(`FB: Event '${eventName}' logged successfully with params:`, params);
            }).catch((err) => {
                console.error(`FB: Failed to log event '${eventName}':`, err);
            });
        } else {
            FacebookEvents.logEvent({ event: eventName })
                .then(() => {
                    console.log(`FB: Event '${eventName}' logged successfully.`);
                })
                .catch((err) => {
                    console.error(`FB: Failed to log event '${eventName}':`, err);
                });
        }
    }
}
